export default __webpack_public_path__ + "static/media/spanish.519203aa.jpg";